// extracted by mini-css-extract-plugin
module.exports = {"qrcode":"QRCode_qrcode_iEnXp","trigger":"QRCode_trigger_3EXRA","qr":"QRCode_qr_2kaCp","desc":"QRCode_desc_2rnxo","tips":"QRCode_tips_1D5LG"};